// 环境变量优先级
// npm start: .env.development.local, .env.development, .env.local, .env
// npm run build: .env.production.local, .env.production, .env.local, .env
// npm test: .env.test.local, .env.test, .env (note .env.local is missing)
import Platform from "./platform.config.gen"
const location = window.location
export const IS_DEV_ENV = process.env.NODE_ENV === "development"
export const API_BI = process.env.REACT_APP_API_BI
export const API = process.env.REACT_APP_API_DMP
export const AUTH_URL = process.env.REACT_APP_URL_AUTH
export const CLOUD_URL = process.env.REACT_APP_URL_CLOUD
export const CLOUD_API = process.env.REACT_APP_API_CLOUD
export const APPID = process.env.REACT_APP_APPID
export const LOCATION_API = process.env.REACT_APP_API_LOCATION
export const COOKIE_DOMAIN = location.host
  .replace(/:\d+$/, "")
  .replace(/^.*((\.[\w-]+){2})$/, "$1")
export const IS_HTTPS = location.protocol === "https:"
export const HostName = location.host.split(".")[0]
export const NOT_BI = HostName !== "bi"
export const IS_HW = HostName === "hwybi"
export const LOGO_URL = process.env.REACT_APP_URL_LOGO
  ? process.env.REACT_APP_URL_LOGO
  : require("../common/img/hw_wayz_logo.png")
export const BI_URL =
  IS_DEV_ENV || NOT_BI ? location.origin : process.env.REACT_APP_BI
export const PROD = Platform.prodName
export const STATISTIC = Platform.statistic

// @ts-ignore
export const IS_MICRO = window.__POWERED_BY_QIANKUN__

// 登录地址
export const PASSPORT_URL = `${window.location.origin}/passport/#`

// ZHISHU
export const ZHISHU_URL = process.env.REACT_APP_ZHISHU
